import React from "react";
import { useFooter } from "../../lib/varFooter";

let currentDate = new Date();

const Footer = () => {
    const { footer } = useFooter();
    return (
        <div className='footer'>
            <div>Rocksmith+ is a registered or unregistered trademark of <a href='https://ubisoft.com/'>Ubisoft Entertainment</a></div>
            <div>Data from {footer.api_attribution} <a href={footer.api_license_url}>{footer.api_license}</a> with help form voluntairs</div>
            <div>API version {footer.api_version} @ {footer.api_server_name}: {footer.api_server_time}</div>
            <div>Page and design by Skippern &copy; 2023-{currentDate.toISOString().substring(0,4)}</div>
            <div>&nbsp;</div>
        </div>
    )
}

export default Footer